import { Table } from 'antd';
import GiAPI from 'apis/GiAPI';
import { CheckIcon, ThreeDotIcon } from 'assets/svg';
import { IPagingResponse } from 'interface/base.interface';
import { IGi } from 'interface/gi.interface';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import formatDateWithTime from 'utils/formatDateWithTime';
import { HocChangePagination } from 'utils/HocChangePagination';
import { translateGIStatus } from 'utils/translateStatus';
import GIDetailModal from './GIDetailModal';
interface IProps {
  dataSource?: IPagingResponse<IGi>;
  disableButton?: () => void;
  enableButton?: () => void;
  hasSelection: boolean;
  page: number;
  // total: number;
  page_size: number;
  getSelectedRow?: (documents: string[]) => void;
}

export default function GIEditTable(props: IProps): JSX.Element {
  const {
    dataSource,
    disableButton,
    enableButton,
    page,
    // total,
    getSelectedRow,
    page_size,
  } = props;

  const history = useHistory();

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [currentGi, setCurrentGi] = useState<string>('');

  const onSelectChange = (selectedRowKeys: any, selectedRows: any) => {
    if (!enableButton || !disableButton) return;

    if (selectedRowKeys.length > 0) {
      enableButton();
    } else {
      disableButton();
    }

    const documents = selectedRows.map((row: any) => row.document);

    getSelectedRow && getSelectedRow(documents);
  };

  const rowSelection = {
    onChange: onSelectChange,
  };

  const handleShowGIDetailModal = (record: IGi) => {
    setIsModalVisible(true);
    setCurrentGi(record.document);
  };

  const { data: GIDetials } = useQuery(
    ['getGIDetails', currentGi],
    () => GiAPI.getGIDT(currentGi),
    { enabled: !!currentGi }
  );

  const columns = [
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (_: any, record: any) => (
        <span>{translateGIStatus(record.status)}</span>
      ),
    },
    {
      title: 'Mã GI',
      dataIndex: 'document',
      key: 'document',
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_: any, record: any) => (
        <span>{formatDateWithTime(record.createdAt)}</span>
      ),
    },
    {
      title: 'Người tạo',
      dataIndex: 'createBy',
      key: 'createBy',
    },
    {
      title: 'Đã duyệt',
      dataIndex: 'active',
      key: 'active',
      render: (active: boolean) => (
        <div className="flex justify-center">{active && <CheckIcon />}</div>
      ),
    },
    {
      title: 'Đơn vị xuất',
      dataIndex: 'plant',
      key: 'plant',
    },
    {
      title: 'Đơn vị nhận',
      dataIndex: 'receivingPlant',
      key: 'receivingPlant',
    },
    {
      title: 'Địa chỉ nhận',
      dataIndex: 'receivingPlantAddress',
      key: 'receivingPlantAddress',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'plantPhoneNumber',
      key: 'plantPhoneNumber',
    },
    // {
    //   title: 'Mã GR',
    //   dataIndex: 'grCode',
    //   key: 'grCode',
    // },
    // {
    //   title: 'Người tạo',
    //   dataIndex: 'createBy',
    //   key: 'createBy',
    // },
    // {
    //   title: 'Thời gian tạo',
    //   dataIndex: 'createdQrAt',
    //   key: 'createdQrAt',
    // },
    // {
    //   title: 'Shipper',
    //   dataIndex: 'shipperName',
    //   key: 'shipperName',
    // },
    // {
    //   title: 'Phương tiện',
    //   dataIndex: 'vehicleType',
    //   key: 'vehicleType',
    // },
    // {
    //   title: 'Thời gian nhận',
    //   dataIndex: 'receivedAt',
    //   key: 'receiviedAt',
    // },
    // {
    //   title: 'SDT Shipper',
    //   dataIndex: 'shipperPhoneNumber',
    //   key: 'shipperPhoneNumber',
    // },
    {
      title: 'Chi tiết',
      dataIndex: 'detail',
      key: 'detail',

      render: (_: any, record: any) => (
        <div className="flex justify-center">
          <button
            onClick={() => handleShowGIDetailModal(record)}
            className="outline-none"
          >
            <ThreeDotIcon className="flex justify-center" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey={(_, index) => index + ''}
        className="customTable"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={dataSource?.data}
        pagination={{
          current: page,
          pageSize: page_size,
          total: dataSource?.total,
          onChange: HocChangePagination(history),
        }}
      />
      {GIDetials && (
        <GIDetailModal
          gi={GIDetials}
          isVisible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
        />
      )}
    </>
  );
}
